import { Button, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <Stack align="flex-start">
      <Title order={2}>{t('notFound.title')}</Title>
      <Text c="dimmed">{t('notFound.description')}</Text>
      <Button component={Link} to="/" variant="light">
        {t('notFound.back')}
      </Button>
    </Stack>
  );
}
